import { handleActions } from 'redux-actions'

import {
  createBlogRequest,
  createBlogSucceed,
  getBlogDetailRequest,
  getBlogDetailSucceed,
  getBlogListRequest,
  getBlogListSucceed,
  getBlogStatusStatisticsRequest,
  getBlogStatusStatisticsSucceed,
  requestFailure,
  updateBlogRequest,
  updateBlogStatusRequest,
  updateBlogStatusSucceed,
  updateBlogSucceed
} from './actions'

export const INITIAL_STATE = {
  processing: {
    getBlogList: false,
    getBlogDetail: false,
    createOrUpdatingBlog: false,
    getBlogStatistics: false
  },
  blogList: null,
  blogDetail: null,
  blogStatistics: null
}

type State = typeof INITIAL_STATE

export const blogReducer = handleActions<State, any>(
  {
    [getBlogStatusStatisticsRequest.toString()]: (state) => ({
      ...state,
      processing: {
        ...state.processing,
        getBlogStatistics: true
      }
    }),
    [getBlogStatusStatisticsSucceed.toString()]: (state, { payload }) => ({
      ...state,
      processing: {
        ...state.processing,
        getBlogStatistics: false
      },
      blogStatistics: payload
    }),
    [getBlogListRequest.toString()]: (state) => ({
      ...state,
      processing: {
        ...state.processing,
        getBlogList: true
      }
    }),
    [getBlogListSucceed.toString()]: (state, { payload }) => ({
      ...state,
      processing: {
        ...state.processing,
        getBlogList: false
      },
      blogList: payload
    }),
    [getBlogDetailRequest.toString()]: (state) => ({
      ...state,
      processing: {
        ...state.processing,
        getBlogDetail: true
      }
    }),
    [getBlogDetailSucceed.toString()]: (state, { payload }) => ({
      ...state,
      processing: {
        ...state.processing,
        getBlogDetail: false
      },
      blogDetail: payload
    }),
    [createBlogRequest.toString()]: (state) => ({
      ...state,
      processing: {
        ...state.processing,
        createOrUpdatingBlog: true
      }
    }),
    [createBlogSucceed.toString()]: (state) => ({
      ...state,
      processing: {
        ...state.processing,
        createOrUpdatingBlog: false
      }
    }),
    [updateBlogRequest.toString()]: (state) => ({
      ...state,
      processing: {
        ...state.processing,
        createOrUpdatingBlog: true
      }
    }),
    [updateBlogSucceed.toString()]: (state, { payload }) => ({
      ...state,
      processing: {
        ...state.processing,
        createOrUpdatingBlog: false
      },
      blogDetail: payload
    }),
    [updateBlogStatusRequest.toString()]: (state) => ({
      ...state,
      processing: {
        ...state.processing,
        createOrUpdatingBlog: true
      }
    }),
    [updateBlogStatusSucceed.toString()]: (state, { payload }) => ({
      ...state,
      processing: {
        ...state.processing,
        createOrUpdatingBlog: false
      },
      blogDetail: payload
    }),
    [requestFailure.toString()]: (state) => ({
      ...state,
      processing: INITIAL_STATE.processing
    })
  },
  INITIAL_STATE
)
